// src/components/SubscriptionExpiredScreen.js
//
// One-page notice shown to NON-superusers when the company subscription is
// expired. Rendered by AppLayout as the main content (top header + sign-out stay
// as BAU; side nav is dropped). Does NOT sign the user out — they leave via the
// usual top-right menu. Copy intentionally says "account owner / a superuser"
// (not "your administrator" — admins are blocked too and cannot renew).
import React from "react";
import Icon from "./icons/Icon";

const SubscriptionExpiredScreen = () => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: "80px 24px",
      minHeight: "60vh",
    }}
  >
    <div style={{ marginBottom: 16 }}><Icon name="lock" size={56} /></div>
    <h1
      style={{
        fontSize: "1.5rem",
        fontWeight: 700,
        color: "var(--ui-text)",
        marginBottom: 12,
      }}
    >
      Subscription Expired
    </h1>
    <p
      style={{
        fontSize: "0.95rem",
        color: "var(--ui-text-muted)",
        maxWidth: 460,
        lineHeight: 1.6,
      }}
    >
      Your company&apos;s Sahod subscription has expired, so access is temporarily
      paused. Please contact your account owner or a superuser to renew the
      subscription and restore access for the team.
    </p>
  </div>
);

export default SubscriptionExpiredScreen;
